import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
} from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { t } from '~/helpers';

import { Modal } from '~/components';

import history from '~/services/history';

import { Report } from '~/components';
import {
  RadioGroup,
} from '~/components/Form';

import * as Yup from 'yup';

import { resetParams } from '~/store/modules/hooks/actions';


import { default as FormRelTela } from './FormRelTela';

function DlgRelEstoque() {
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const formRelTelaRef = useRef(null);
  const reference = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [dataObjto, setDataObjto] = useState({});

  const data = useSelector((state) => state.servicedlgrelestoque);

  function handleSerializeForm(params) {

    let obj = {
      ...params,
      dataObjto
    }

    params = { ...obj };


    if (params.tipo == 'tela') {
      let data = {
        ...params,
      };

      handleDispatch(data);

      setOpen(false);
    } else {
      return {
        ...params,
        idtarefapath: "dlgRelEstoque.swf"
      };
    }
  }


  const handleValidate = useCallback(async (data) => {
    try {
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);


  const handleDispatch = useCallback(async (params) => {
    setShowForm(true);
    formRelTelaRef.current.handleOpenModal({ params: params });
  });


  useEffect(() => {
    if (open) {
      dispatch(resetParams());
    } else {
      if (!showForm) {
        history.push('/dlgRelEstoque.swf');
      }
    }
  }, [open, showForm]);


  const handleReopenForm = useCallback(() => {
    setOpen(true);
    setShowForm(false);
  }, []);

  const handleGetDatat = useCallback((value) => {
    setDataObjto(value);
    console.log('handleGetDatat', value);
  }, []);


  return (
    <>
      <Report
        ref={reference}
        open={open}
        onClose={() => setOpen(false)}
        title="Relatorio de Estoque"
        relatorio="ESTOQUE"
        validate={handleValidate}
        serialize={(param) => handleSerializeForm(param)}
        initials={{

        }}
      >


        <RadioGroup
          name="tipo"
          label="Formato"
          options={[
            { label: 'PDF', value: 'pdf' },
            { label: 'Excel', value: 'xls' },
            { label: 'Tela', value: 'tela' },
          ]}
          defaultValue="tela"
          serialize={(value) => value}
          row
        />
      </Report>

      {showForm && (
        <>

        </>
      )}

      <Modal
        ref={formRelTelaRef}
        disableBackdropClick
        disableEscapeKeyDown
        component={FormRelTela}
        title="Relatório de Estoque"
        loading={loading}
        maxWidth="xl"
        // form
        actions={[
          {
            label: t('s.geral.botaofechar'),
            callback: () => formRelTelaRef.current.handleCloseModal(),
            color: 'secondary',
          },
        ]}
        onClose={() => handleReopenForm()}
        pdf
        xls
      />



    </>
  );
}

export default DlgRelEstoque;
